import * as React from 'react';
import { cx, noop } from '../../utils';
import StyledCheckbox from './Checkbox.styles';

export interface CheckboxProps {
  /**
   * Checkbox id
   */
  id?: string;
  /**
   * Checkbox className
   */
  className?: string;
  /**
   * Checkbox name
   */
  name?: string;
  /**
   * Checkbox value
   */
  value?: string;
  /**
   * Whether this checkbox is checked initially or not
   */
  checked?: boolean;
  /**
   * Checkbox label
   */
  label?: string;
  /**
   * Change radio buttons active state color
   */
  color?:
    | 'accent'
    | 'caution'
    | 'chotot'
    | 'critical'
    | 'error'
    | 'info'
    | 'neutral'
    | 'positive'
    | 'primary'
    | 'secondary'
    | 'success';
  /**
   * Whether this checkbox is disabled initially or not
   */
  disabled?: boolean;
  /**
   * Change event
   */
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

/**
 * Renders a checkbox element.
 *
 * `✅ Stable`
 */
const Checkbox: React.FC<CheckboxProps> = ({
  id = '',
  className = '',
  name = '',
  value = '',
  checked = false,
  label = '',
  color = 'primary',
  disabled = false,
  onChange = noop,
}) => {
  const type = 'checkbox';
  const inputAttrs = {
    id,
    name,
    value,
    type,
    disabled,
  };
  const checkboxClasses = cx(className, disabled && 'disabled', label && 'withLabel', color);

  const _onChange = (e) => {
    e.persist();
    onChange(e);
  };

  return (
    <StyledCheckbox className={checkboxClasses}>
      <input {...inputAttrs} onChange={_onChange} checked={checked} />
      <span className={type} />
      {label}
    </StyledCheckbox>
  );
};

export default Checkbox;
